<ng-container
    *ngIf="
        brandsList?.length &&
        (brandTypeData?.isSlider == 'slider' ||
            brandTypeData?.isSlider == 'none')
    "
>
<div class="">
  <h3 class="lable title py-2 px-3 border-background-none">{{ "productDetails.featuredBrands" | translate }}</h3>
  <div class=" pb-5 pt-2" style="margin: 0 5px;">
      <div class="swiper-container">
          <swiper [config]="SwiperConfig" class="mySwiper" #newSwiper>
              <ng-template
                  swiperSlide
                  *ngFor="let brand of brandsList"
                  class="swiper-slide"
              >
                  <div class="single-brand p-0" style="cursor: pointer">
                      <a
                          (click)="redirectToBrand(brand)"
                          style="margin: 0px auto !important"
                          class="brand-item"
                      >
                          <div
                              style="
                                  width: 120px;
                                  height: 120px;
                                  display: inline-block;
                              "
                              [ngClass]="{
                                  'radius-50':
                                      brandTypeData?.isSqure == 'round'
                              }"
                          >
                              <img  loading="lazy" 
                                  [ngClass]="{
                                      'radius-50':
                                          brandTypeData?.isSqure == 'round'
                                  }"
                                  [src]="brand.image"
                                     [alt]="brand.image"
                                  class="swiper-lazy"
                                  onError="this.src='./assets/images/placeholder200.jpg';"
                                  default="./assets/images/placeholder200.jpg"
                                  width="120"
                                  height="120"
                                  style="
                                      position: relative;
                                      top: 0px;
                                      left: 0px;
                                      margin-left: 0px;
                                      margin-right: 0px;
                                      object-fit: contain;
                                  "
                              />
                  
                          </div>
                          <div *ngIf="environmentVariables?.ENABLE_SHOW_BRAND_NAME">
                              <h3 style="color: var(--secoundry-color)">
                                  {{
                                      lang == "en"
                                          ? brand.name
                                          : brand.name_ar
                                  }}
                              </h3>
                          </div>
                      </a>
                  
                  </div>
              </ng-template>
          </swiper>
      </div>
  </div>
</div>
 
</ng-container>

<ng-container *ngIf="brandsList?.length && brandTypeData.isSlider !== 'slider'">
  <div class="">
    <h3 class="lable  title py-2 px-3 border-background-none">{{ "productDetails.featuredBrands" | translate }}</h3>
    <div class="">
        <div class="row brands-grid">
            <div
                class="p-0 single-brand"
                style="cursor: pointer"
                style="margin-bottom: 10px"
                *ngFor="let brand of brandsList"
            >
                <a
                    (click)="redirectToBrand(brand)"
                    style="margin: 0px auto !important"
                    class="brand-item"
                >
                    <div
                        class="imgContainer mb-4 mx-2"
                        [ngClass]="{
                            'radius-50': brandTypeData?.isSqure == 'round'
                        }"
                    >
                        <img  loading="lazy" 
                            [ngClass]="{
                                'radius-50': brandTypeData?.isSqure == 'round'
                            }"
                            [src]="brand.image"
                               [alt]="brand.image"
                            onError="this.src='./assets/images/placeholder200.jpg';"
                            default="./assets/images/placeholder200.jpg"
                            style="
                                position: relative;
                                top: 0px;
                                left: 0px;
                                margin-left: 0px;
                                margin-right: 0px;
                                object-fit: contain;
                            "
                        />
                        <div *ngIf="environmentVariables?.ENABLE_SHOW_BRAND_NAME">
                            <h3
                                class="text-center"
                                style="color: var(--secoundry-color)"
                            >
                                {{ lang == "en" ? brand.name : brand.name_ar }}
                            </h3>
                        </div>
                    </div>
                    <!-- <div>
              <h3 class="text-center" style="color: var(--secoundry-color);">
                {{ lang == "en" ? brand.name : brand.name_ar }}
              </h3>
            </div> -->
                </a>
            </div>
        </div>
    </div>
  </div>

</ng-container>
